module.exports = __webpack_public_path__ + "img/product-shdf.60665695.png";